const errorHandler = (error) => {
  if (
    error?.response?.status === 401 &&
    window.location.pathname !== "/auth/login"
  ) {
    localStorage.clear();
    window.location.href = "/auth/login";
  }
  return Promise.reject(error);
};

const responseHandler = (response) => {
  if (
    (response?.data?.status === 401 || response?.data?.statusCode === 401) &&
    window.location.pathname !== "/auth/login"
  ) {
    localStorage.clear();
    window.location.href = "/auth/login";
    return;
  }
  return response;
};

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken, practice_id, user },
        providerNote: { selectedNote },
      } = store.getState();
      if (authToken) {
        config.params = {
          token: authToken,
          tz: new Date().getTimezoneOffset(),
          portal: "provider",
          actor_id: user?.id,
          ...config.params,
        };
      }
      if (practice_id) {
        config.params = { practice_id: practice_id, ...config.params };
      }
      if (!config?.params?.skip_encounter && selectedNote?.encounter) {
        config.params.encounter =
          config?.params?.force_encounter || selectedNote?.encounter;
      }
      if (window.enable_log_sql) {
        config.params.log_sql = window.enable_log_sql;
      }
      config.params.e10x = 1;
      const date = new Date();
      config.params = { tz: date.getTimezoneOffset(), ...config.params };
      return config;
    },
    (error) => errorHandler(error)
  );

  axios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  );
}
